import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LinkService {
    getDetailLinkAsArray(urlPrefix: string, title: string, id: string): string[] {
        const detailLink: string[] = [];
        if (urlPrefix) {
            detailLink.push(urlPrefix);
        }
        if (title) {
            detailLink.push(this.convertSpacesToHyphens(title));
        }
        if (id) {
            detailLink.push(id);
        }
        return detailLink;
    }

    getDetailLinkAsString(urlPrefix: string, title: string, id: string): string {
        let detailLink = '';
        const trimmedUrlPrefix = this.trimSlashes(urlPrefix);
        if (trimmedUrlPrefix) {
            detailLink += `/${trimmedUrlPrefix}`;
        }
        const trimmedTitle = this.trimSlashes(title);
        if (trimmedTitle) {
            detailLink += `/${this.convertSpacesToHyphens(trimmedTitle)}`;
        }
        const trimmedId = this.trimSlashes(id);
        if (trimmedId) {
            detailLink += `/${trimmedId}`;
        }
        return detailLink;
    }

    private convertSpacesToHyphens(url: string) {
        return url.split(/\s+/).join('-');
    }

    private trimSlashes(url: string): string {
        const found = new RegExp('[^/].*[^/]').exec(url);
        return found ? found[0] : '';
    }
}
